var React = require('react');

function IcMenu36px (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 27h28v-3H4v3zm0-8h28v-3H4v3zM4 8v3h28V8H4z"}));
}

IcMenu36px.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = IcMenu36px;

IcMenu36px.default = IcMenu36px;
